import React, { useEffect, useState } from "react"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "../AppComponents/Games.scss"
import _ from "lodash";
import GameCard from "./../commonComponents/GameCard"
import { useLocation } from 'react-router-dom'
function Category({play,setshowSideMenu,setCenterLogo,setRightLogo}) {
    const location = useLocation()   
    const [curData,setCurData]=useState([])
    const [isLoading,setIsLoading]=useState(true)
    const [categoryName,setCategoryName]=useState("similar")
    
    useEffect(()=>
    {
       
        // changeLogo()
        let items=JSON.parse(localStorage.getItem('category_data'));
        let cName=JSON.parse(localStorage.getItem('category_name'));
        setCurData(location.state?location.state.categoryData:items)
        setCategoryName(location.state?location.state.datacategory:cName);
        setIsLoading(false)
       
        // console.log("Items are ::",items);
        // console.log("location is:",location.state)
    },[]);
     console.log('inside category container::',curData)
     function capatalize(categoryName) {
        return categoryName.charAt(0).toUpperCase() + categoryName.slice(1);
    }
    useEffect(() => {
        if(curData!='undefined' && curData!='' && curData!=null && curData!=[])
        {
            localStorage.setItem('category_data', JSON.stringify(curData));
            localStorage.setItem('category_name', JSON.stringify(curData[0].category));
          
        } 
    }, [curData]);
   

    return (
        <>
        {isLoading?<div className="lds"></div>:
        <div className="container m-w">
            <div className="columns is-multiline is-mobile common is-gapless">
                <div className="column is-full v-center">
                    <h6 className="title is-6 has-text-white mb-0"> {capatalize(categoryName)} Games</h6>
                </div>
                <div className="column mt-3 is-full">
                    {
                        curData &&  curData.length>0 && curData.map((item, i) => (
                            <GameCard key={item.id} data={item} play_text={play}/>
                        ))
                    }
                </div>
            </div>
        </div>}
        </>
    )
}
export default Category